module.exports = __webpack_public_path__ + "img/ywt_list_img6.f6e0e4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/ywt_list_img6.png
// module id = lhW3
// module chunks = 136